import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useForm from 'src/helpers/useForm'
import Button from 'src/global/Button'
import { State } from 'src/state'
import { userEndpoints } from 'src/api'
import { logOut } from 'src/state/users'

export default function ChangePassword() {
  const dispatch = useDispatch()
  const { formValues, register } = useForm()
  const { isLoading: loading } = useSelector((state: State) => state.users)

  const submit = async () => {
    const oldPassword = formValues.oldPassword?.value || ''
    const newPassword = formValues.newPassword?.value || ''
    const newPasswordAgain = formValues.newPasswordAgain?.value || ''

    if (newPassword.length < 6) {
      await window.showConfirm({ text: `Parola trebuie să aibă cel puțin 6 caractere.` })
      return
    }

    if (newPassword !== newPasswordAgain) {
      await window.showConfirm({ text: `Parolele nu sunt la fel.` })
      return
    }

    await userEndpoints.changePassword({ oldPassword, newPassword, newPasswordAgain })
    await window.showConfirm({ text: `Parola a fost schimbată cu succes.` })

    dispatch(logOut())
    localStorage.clear()
    sessionStorage.clear()
    window.location.reload()
  }

  return (
    <div className="page">
      <form
        //@ts-ignore
        loading={loading}
        onSubmit={e => {
          e.preventDefault()
          submit()
        }}
      >
        <label>parola curentă</label>
        <input type="password" maxLength={50} placeholder="parola curentă" {...register('oldPassword')} />

        <label>parola nouă</label>
        <input type="password" maxLength={50} placeholder="parolă nouă" {...register('newPassword')} />

        <label>confirmă parola nouă</label>
        <input type="password" maxLength={50} placeholder="confirmă parola nouă" {...register('newPasswordAgain')} />

        <Button type="submit" text="Schimbă" />
      </form>
    </div>
  )
}
